<template>
  <div>
    <div v-if="editLink" class="mb-8">
      <h2 class="text-center">
        {{ "Edit Join Link - " + $route.params.linkId }}
      </h2>
    </div>
    <div v-else class="mb-8">
      <h2>Create a new Link</h2>
    </div>
    <div>
      <div class="w-2/3 m-auto mb-2">
        <label for="link-name"
          >Name <span class="text-red ml-2">*</span
          ><small class="ml-2 text-sm"
            >(Link URL: <span class="text-blue">{{ getLinkURL }})</span></small
          ></label
        >
        <input
          id="link-name"
          v-model="joinLink.name"
          v-validate="'required'"
          type="text"
          name="name"
          class="w-full"
          @input="handleJoinLinkNameInput"
        />
        <small class="err-msg text-red block mt-2 mb-2">
          {{ veeValidateErrors.first("name") }}
        </small>
      </div>
      <div class="w-2/3 m-auto mb-2">
        <label for="link-title"
          >Title<span class="text-red ml-2">*</span></label
        >
        <input
          id="link-title"
          v-model="joinLink.meta.title"
          v-validate="'required'"
          type="text"
          name="title"
          class="w-full"
        />
        <small class="err-msg text-red block mt-2 mb-2">
          {{ veeValidateErrors.first("title") }}
        </small>
      </div>
      <div class="w-2/3 m-auto mb-2">
        <div>
          <button
            class="flex items-center justify-center font-normal bg-green text-white rounded-sm hover:bg-green-dark focus:bg-green-dark"
            style="min-width: 16rem;"
            @click="showImageUploadWidget = true"
          >
            Upload Institution Logos
            <i class="material-icons cursor-pointer ml-4">cloud_upload</i>
          </button>
          <div
            v-if="joinLink.college_logos && joinLink.college_logos.length > 0"
            class="mt-2"
          >
            <p>Institution Logos</p>
            <div class="flex justify-start items-center my-2">
              <div
                v-for="(link, idx) in joinLink.college_logos"
                :key="link + idx"
                class="mr-2 img-container relative"
              >
                <button
                  class="remove-img-button"
                  @click="removeUploadedImage(link)"
                >
                  <i
                    class="material-icons cursor-pointer text-red"
                    style="font-size:2rem;"
                    >highlight_off</i
                  >
                </button>
                <img
                  :src="link"
                  alt="college logo preview"
                  class="w-full h-full"
                />
              </div>
            </div>
          </div>
        </div>
        <AWSS3UploadWidget
          v-if="showImageUploadWidget"
          :serverUrl="imageUploadServerURL"
          dropZoneTitle="Select or drag and drop college logo here to upload"
          :category="imageUploadConfig.uploadFolder"
          @FILE_UPLOAD_SUCCESS="handleImageUpload"
          @CLOSE_BUTTON_CLICK="showImageUploadWidget = false"
          @FILE_ADDED="handleFileAddition"
        />
      </div>
      <div class="w-2/3 m-auto mb-2">
        <label for="cohort-id"
          >Cohort<span class="text-red ml-2">*</span></label
        >
        <VueSelect
          id="cohort-id"
          v-model="joinLink.cohort_id"
          v-validate="'required'"
          placeholder="Select a Cohort"
          :options="cohortList"
          :reduce="cohort => cohort.name"
          label="name"
          name="cohort"
        />
        <small class="err-msg text-red block mt-2 mb-2">
          {{ veeValidateErrors.first("cohort") }}
        </small>
      </div>
      <small class="w-2/3 m-auto text-red block"
        >* To allow anyone to come and signup, please uncheck Restrict by
        Institute tags and Restrict by Email.
      </small>
      <div class="mt-2 mb-2 mx-2">
        <div class="w-2/3 m-auto flex items-center">
          <label for="institution-restrict">Restrict by Institute Tags?</label>
          <input
            id="institution-restrict"
            v-model="joinLink.institution_tags_are_restricted"
            class="ml-3 -mt-3"
            type="checkbox"
            name="institution-restrict"
          />
        </div>
        <div
          v-if="joinLink.institution_tags_are_restricted"
          class="w-2/3 m-auto"
        >
          <label for="">Approved Institutions</label>
          <VueSelect
            v-model="joinLink.approved_institution_tag_ids"
            placeholder="Select Tags"
            label="name"
            :options="tagOptions"
            :reduce="tag => tag.name"
            multiple
            taggable
          />
        </div>
      </div>
      <div class="w-2/3 m-auto mb-2">
        <div class="flex items-center">
          <label for="email-restrict">Restrict by email?</label>
          <input
            id="email-restrict"
            v-model="joinLink.emails_are_restricted"
            class="ml-3 -mt-3"
            type="checkbox"
            name="email-restrict"
          />
        </div>
        <div v-if="joinLink.emails_are_restricted" class="w-full m-auto">
          <label for="user-id">Approved Emails ({{ getEmailCount() }})</label>
          <textarea
            id="user-id"
            v-model.trim="joinLink.approved_emails"
            rows="5"
            cols="30"
            class="p-3 border w-full"
            placeholder="Email (separated by comma or newline)"
          />
        </div>
      </div>
      <div class="w-2/3 m-auto mb-2 flex items-center">
        <label for="is-enabled"
          ><span class="text-red mr-2">*</span>Is Enabled</label
        >
        <input
          id="is-enabled"
          v-model="joinLink.is_enabled"
          class="ml-3 -mt-3"
          type="checkbox"
          name="link-active"
        />
      </div>
      <div class="w-2/3 m-auto mb-2">
        <div class="flex items-center">
          <label for="send_email_notification">Send Email Notifications</label>
          <input
            id="send_email_notification"
            v-model="joinLink.send_email_notification"
            class="ml-3 -mt-3"
            type="checkbox"
          />
        </div>
        <div v-if="joinLink.send_email_notification">
          <div class="w-full m-auto">
            <label for="email-subject">Email Subject</label>
            <textarea
              id="email-subject"
              v-model.trim="joinLink.email_subject"
              class="p-3 border w-full"
              placeholder="Enter subject"
            />
          </div>
          <div class="w-full m-auto mb-12">
            <label for="signup-email-body">Email Body</label>
            <QuillEditor
              ref="myQuillEditor"
              v-model="joinLink.signup_email_body"
              style="height: 200px;"
              :options="quillEditorOptions"
            />
          </div>
        </div>
      </div>
      <div class="w-2/3 m-auto mt-4">
        <h4>
          Auth Providers
          <span class="text-xs font-normal text-grey-darker"
            >* Students will be allowed to join via selected providers
            only</span
          >
        </h4>

        <div class="flex items-center auth-providers mt-4">
          <label for="google">Google</label>
          <input
            id="Google"
            v-model="joinLink.allowed_auth_providers"
            type="checkbox"
            class="mr-4"
            value="google"
          />
          <label for="facebook">Facebook</label>
          <input
            id="Facebook"
            v-model="joinLink.allowed_auth_providers"
            type="checkbox"
            class="mr-4"
            value="facebook"
          />
          <label for="microsoft">Microsoft</label>
          <input
            id="Microsoft"
            v-model="joinLink.allowed_auth_providers"
            type="checkbox"
            class="mr-4"
            value="microsoft"
          />
        </div>
      </div>
      <div class="w-2/3 m-auto text-right">
        <button
          class="border m-4 mt-16 mb-12 p-2 px-12 rounded-full bg-green text-white font-bold"
          @click="handleSubmit"
        >
          {{ editLink ? "Update" : "Create" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import { quillEditor } from "vue-quill-editor"
import AWSS3UploadWidget from "@edyst/shared-components/src/components/AWSS3UploadWidget"
import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    VueSelect,
    QuillEditor: quillEditor,
    AWSS3UploadWidget,
  },
  data() {
    return {
      imageUploadServerURL: `${siteConfig.siteURL}uploads/public`,
      showImageUploadWidget: false,
      imageFilesCount: 0,
      joinLink: {
        name: "",
        is_enabled: true,
        cohort_id: "",
        meta: { title: "" },
        approved_emails: "",
        approved_institution_tag_ids: [],
        institution_tags_are_restricted: true,
        emails_are_restricted: true,
        send_email_notification: false,
        email_subject: "",
        signup_email_body: "",
        allowed_auth_providers: ["google", "facebook"],
        college_logos: [],
      },
      cohortList: [],
      tagOptions: [],
      quillEditorOptions: {
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            ["blockquote", "code-block"],
            [{ indent: "-1" }, { indent: "+1" }],
            ["clean"],
          ],
        },
        placeholder: "Enter your comments here...",
        readOnly: false,
        theme: "snow",
      },
    }
  },
  computed: {
    imageUploadConfig() {
      return {
        uploadMultiple: true,
        uploadFolder: "join-link-college-logos",
      }
    },
    getLinkURL() {
      if (this.joinLink && this.joinLink.name) {
        return `https://edyst.com/join/${this.joinLink.name}`
      }
      return ""
    },
    editLink() {
      return !!this.$route.params.linkId
    },
  },
  async created() {
    await this.fetchCohorts()
    this.getTags().then(res => {
      this.tagOptions = res.data.tags
      if (this.editLink) {
        this.fetchLink()
      }
    })
  },
  methods: {
    handleFileAddition() {
      this.imageFilesCount += 1
    },
    handleImageUpload(imageURL) {
      this.joinLink.college_logos.push(imageURL)
      if (this.imageFilesCount === this.joinLink.college_logos.length) {
        this.showImageUploadWidget = false
      }
    },
    removeUploadedImage(url) {
      this.joinLink.college_logos = this.joinLink.college_logos.filter(
        item => item !== url
      )
      this.imageFilesCount -= 1
    },
    handleJoinLinkNameInput() {
      if (this.joinLink.name) {
        this.joinLink.name = this.joinLink.name.split(" ").join("-")
      }
    },
    fetchLink() {
      this.axios({
        method: "GET",
        url: `${siteConfig.siteURL}admin/join_links/${this.$route.params.linkId}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(async res => {
        const joinLink = {
          name: res.data.join_link.name,
          is_enabled: res.data.join_link.is_enabled,
          cohort_id: res.data.join_link.cohort,
          meta: { title: res.data.join_link.meta.title },
          institution_tags_are_restricted:
            res.data.join_link.institution_tags_are_restricted,
          emails_are_restricted: res.data.join_link.emails_are_restricted,
          approved_emails: res.data.join_link.approved_emails.join("\n"),
          approved_institution_tag_ids:
            res.data.join_link.approved_institution_tags,
          send_email_notification: res.data.join_link.send_email_notification,
          email_subject: res.data.join_link.email_subject,
          signup_email_body: res.data.join_link.signup_email_body,
          allowed_auth_providers: res.data.join_link.allowed_auth_providers,
          college_logos: res.data.join_link.college_logos || [],
        }
        this.joinLink = joinLink
        this.imageFilesCount = this.joinLink.college_logos.length
      })
    },
    getTags() {
      return this.axios({
        method: "get",
        url: `${siteConfig.siteURL}institution/get_college_tags`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
    },
    fetchCohorts() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}cohorts/?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(cohort_res => {
        this.cohortList = cohort_res.data.items
      })
    },
    getEmailCount() {
      const splitEmailString = emails => {
        const formatCSV = emails.split(",").filter(f => f)
        if (formatCSV.length > 1) {
          return formatCSV.length
        }
        const formatNewLine = emails.split("\n").filter(f => f)
        if (formatNewLine.length) {
          return formatNewLine.length
        }
        return 0
      }
      return splitEmailString(this.joinLink.approved_emails)
    },
    validateEmailNotifications() {
      if (
        this.joinLink.send_email_notification &&
        (!this.joinLink.email_subject || !this.joinLink.signup_email_body)
      ) {
        this.$swal({
          icon: "error",
          text:
            "You set email notification to true, Please give Add Email Subject and Add Email Body.",
        })
      }
    },
    formatData() {
      const joinLink = Object.assign({}, this.joinLink)
      joinLink.cohort_id = joinLink.cohort_id.id
      joinLink.approved_institution_tag_ids = joinLink.approved_institution_tag_ids.map(
        t => t.id
      )
      joinLink.approved_emails = joinLink.approved_emails
        .replace(/\n/g, ",")
        .split(",")

      return joinLink
    },
    createJoinLink() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$noty.error("Please fill all the required fields marked with *")
          return
        }

        this.validateEmailNotifications()
        const data = this.formatData()

        this.axios({
          method: "POST",
          url: `${siteConfig.siteURL}admin/join_links`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
          data,
        })
          .then(res => {
            if (res.data.status) {
              this.$noty.success("Created Join Link successfully")
              this.$router.replace({
                name: "JoinLinks",
                params: { linkId: res.data.join_link.id },
              })
            } else {
              this.$noty.error(
                `Something went wrong. ${
                  res.data.message
                    ? `Server responded with : ${res.data.message}`
                    : ""
                }`
              )
            }
          })
          .catch(err => {
            if (
              err.response.data.message &&
              err.response.data.message.includes("Cohort is being updated")
            ) {
              this.$swal({
                icon: "error",
                text: err.response.data.message,
              })
            }
          })
      })
    },
    updateJoinLink() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$noty.error("Please fill all the required fields marked with *")
          return
        }
        this.validateEmailNotifications()
        const data = this.formatData()

        this.axios({
          method: "PUT",
          url: `${siteConfig.siteURL}admin/join_links/${this.$route.params.linkId}`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
          data,
        })
          .then(res => {
            if (res.data.status) {
              this.$noty.success("Updated Event successfully")
              this.$router.replace({
                name: "JoinLinks",
                params: { linkId: res.data.join_link.id },
              })
            } else {
              this.$noty.error(
                `Something went wrong. ${
                  res.data.message
                    ? `Server responded with : ${res.data.message}`
                    : ""
                }`
              )
            }
          })
          .catch(err => {
            if (
              err.response.data.message &&
              err.response.data.message.includes("Cohort is being updated")
            ) {
              this.$swal({
                icon: "error",
                text: err.response.data.message,
              })
            } else {
              this.$noty.error(
                `Something went worng, server responded with :${err}`
              )
            }
          })
      })
    },
    handleSubmit() {
      if (this.editLink) {
        this.updateJoinLink()
      } else {
        this.createJoinLink()
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
input {
  width: 100%;
  margin-bottom: 10px;
}
button {
  padding: 10px 20px;
  outline: none;
}
label {
  display: block;
  padding: 10px 0px;
  font-size: 16px;
  text-align: left;
}

.auth-providers label {
  margin: 0 0.5rem;
  padding: 0;
}

.img-container {
  width: 100%;
  max-width: 10rem;
  height: 100%;
  max-height: 10rem;
}

.remove-img-button {
  display: flex;
  visibility: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 0;
  background: #ffffffbe;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.img-container:hover .remove-img-button {
  visibility: visible;
}
</style>
